import React from 'react';
import './index.css';
import Section1 from './Section1';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Ecosystem from './Ecosystem';
import WhyOmniflix from './WhyOmniflix';
import InterChainAssets from './InterChainAssets';
import CommunityMiddleware from './CommunityMiddleware';
import MediaAssetPools from './MediaAssetPools';
import InterChainMarkets from './InterChainMarkets';
import Network from './Network';
import Infrastructure from './Infrastructure';
import DApps from './DApps';
import Roadmap from './Roadmap';
import Achievements from './Achievements';
import Partners from './Partners';
import NetworkStats from './NetworkStats';
import ValidatorsOn from './ValidatorsOn';
import Contact from './Contact';
import Subscribe from './Subscribe';
import variables from '../../utils/variables';
import Icon from '../../components/Icon';

const Home = (props) => {
    return (
        <div className="home">
            <Section1 lang={props.lang}/>
            <DApps lang={props.lang}/>
            <Achievements lang={props.lang}/>
            <Partners lang={props.lang}/>
            <NetworkStats lang={props.lang}/>
            <ValidatorsOn lang={props.lang}/>
            <Ecosystem lang={props.lang}/>
            <WhyOmniflix lang={props.lang}/>
            <InterChainAssets lang={props.lang}/>
            <CommunityMiddleware lang={props.lang}/>
            <MediaAssetPools lang={props.lang}/>
            <InterChainMarkets lang={props.lang}/>
            <Roadmap lang={props.lang}/>
            <Infrastructure lang={props.lang}/>
            <Network lang={props.lang}/>
            <Contact/>
            <Subscribe lang={props.lang}/>
            <div className="footer">
                <div className="left_content">
                    <p className="heading_text">{variables[props.lang]['omniflix_network']}</p>
                    <div className="world_text">
                        <p>{variables[props.lang]['world_text1']}</p>
                        <Icon className="heart" icon="heart"/>
                        <p>{variables[props.lang]['world_text2']}</p>
                    </div>
                </div>
                <div className="right_content">
                    <p>{variables[props.lang]['info_mail']}</p>
                </div>
            </div>
        </div>
    );
};

Home.propTypes = {
    lang: PropTypes.string.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
    };
};

export default connect(stateToProps)(Home);
